import CaptableSimulationOperations from './container';

export default CaptableSimulationOperations;
